// extracted by mini-css-extract-plugin
export default {"invalid-age":"InvalidAge_invalid-age__Poods","heading-name-age":"InvalidAge_heading-name-age__teV31","contents-age":"InvalidAge_contents-age__zkUxU"};